import {
  FilledInputProps,
  InputProps,
  OutlinedInputProps,
} from "@mui/material";
import type { TextFieldProps } from "@mui/material/TextField";
import TextField from "@mui/material/TextField";
import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import { numberWithCommas } from "src/utils/helper";

interface Props<T extends FieldValues> extends Omit<TextFieldProps, "name"> {
  control: Control<T>;
  name: FieldPath<T>;
  placeholder?: string;
  adornmentLabel?: string;
  disabled?: boolean;
  allowNegative?: boolean;
  thousandSeparator?: boolean | string;
  onValueChange?: (value?: any) => void;
  InputProps?:
    | Partial<InputProps>
    | Partial<FilledInputProps>
    | Partial<OutlinedInputProps>;
  className?: string;
  helperText?: any;
}

const ControllerNumberField = <T extends FieldValues>(props: Props<T>) => {
  const {
    control,
    name,
    placeholder,
    adornmentLabel,
    disabled,
    allowNegative = false,
    onValueChange,
    thousandSeparator = true,
    InputProps,
    className,
    helperText,
    inputProps,
    ...rest
  } = props;

  return (
    <Controller
      render={({ field, fieldState: { error } }) => (
        <NumberFormat
          inputProps={inputProps}
          customInput={TextField}
          fullWidth
          isNumericString={false}
          defaultValue={null}
          disabled={disabled}
          thousandSeparator={","}
          error={Boolean(error)}
          decimalSeparator={" "}
          helperText={
            helperText
              ? helperText
              : error?.message && <div>{error.message}</div>
          }
          allowNegative={allowNegative}
          placeholder={placeholder}
          className={className}
          format={(value) => numberWithCommas(`${parseInt(value)}`)}
          {...field}
          onValueChange={(value) => {
            field.onChange(value.floatValue ?? null);
          }}
          allowLeadingZeros={false}
          onChange={() => {}}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={InputProps}
        />
      )}
      name={name}
      control={control}
    />
  );
};

export default ControllerNumberField;
